import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { ScratchcardFlash, ScratchcardFlower, ScratchcardStar, ScratchcardWorm, ScratchcardZigZag } from './components';

type ScratchcardBackgroundProps = ComponentProps<'svg'> & {
  position: number;
};

const svgs = [ScratchcardWorm, ScratchcardFlash, ScratchcardZigZag, ScratchcardStar, ScratchcardFlower] as const;

function ScratchcardBackground({ position = 0, className, ...props }: ScratchcardBackgroundProps) {
  const SvgComponent = svgs[(position - 1) % svgs.length] ?? ScratchcardWorm;

  return <SvgComponent className={twMerge('w-full h-full shrink-0', className)} {...props} />;
}

export { ScratchcardBackground, type ScratchcardBackgroundProps };
